<template>
  <div id="service" ref="index">
    <!-- kv -->
    <kv :banner="banner"></kv>
    <!-- 服務項目 -->
    <section class="wrap">
      <div class="container">
        <h2 class="text-secondary mt-30">服務項目</h2>
      </div>
      <section class="service">
        <div class="container">
          <div class="row">
            <div
              class="col-md-6 mt-30"
              v-for="(item, index) in services"
              :key="index"
              :ref="item.no"
              data-aos="flip-up"
              data-aos-once="true"
              :data-aos-delay="index*120"
            >
              <div class="card d-flex align-items-center justify-content-center h-100">
                <img v-if="item.media.data.length >0" class="card-img-top" :src="item.media.data[0].thumb" />
                <div class="card-body">
                  <h4 class="text-center text-primary dashed py-20">{{item.title}}</h4>
                  <div class="py-25" v-html="item.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <div class="back d-flex align-items-center justify-content-center" @click="scrollToTop">
      <i class="material-icons">expand_less</i>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import kv from '@/components/kv.vue';

export default {
  name: 'service',
  metaInfo: {
    title: ' - 服務項目',
  },
  data() {
    return {
      banner: [],
      services: [],
    };
  },
  components: {
    kv,
  },
  computed: {
    ...mapGetters(['screenWidth']),
    kv_id() {
      return this.screenWidth >= 576 ? 3 : 10;
    },
  },
  methods: {
    getBanner() {
      const url = `/banner/${this.kv_id}`;
      this.axios
        .get(url)
        .then((response) => {
          this.banner = response.data.data.file.data;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    getServices() {
      const url = '/article';
      const params = {
        search: 11,
        searchFields: 'category_id',
        orderBy: 'publish_at',
        sortedBy: 'desc',
        limit: 15,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.services = response.data.data;
          this.services.forEach((item) => {
            if (item.content.match(/^pre/g) !== undefined) {
              item.content = item.content.replace(new RegExp('pre>', 'ig'), 'div>');
            }
          });
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.getBanner();
    this.getServices();
    if (this.$route.params.id) {
      const target = this.$route.params.id;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs[target][0].scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }, 800);
      });
    } else {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTop();
        }, 500);
      });
    }
  },
  watch: {
    kv_id() {
      this.getBanner();
    },
  },
};
</script>
<style lang="scss">
@import '~@/assets/scss/all.scss';

#service {
  overflow-x: hidden;
  .wrap {
    position: relative;
    background-color: lighten($sub-primary-white, 2.5%);
    @media (max-width: 1024px) {
      background-image: url('~@/assets/images/leaf.svg'), url('~@/assets/images/leaf2.svg');
      background-size: 170px auto;
      background-repeat: no-repeat;
      background-position: left bottom, right bottom;
    }
    @media (min-width: 1024px) {
      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-image: url('~@/assets/images/bg-circle-left.svg'),
          url('~@/assets/images/bg-circle-right.svg');
        background-size: 170px auto, 170px auto;
        background-repeat: repeat-y, repeat-y;
        background-position: left top, right top;
      }
    }
  }
  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: $primary;
  }
  section:not(.hooper):not(.kv) {
    min-height: 200px;
    padding: 20px 0;
    a {
      color: #000000;
      text-decoration: none;
    }
    // service
    &.service {
      background-color: rgba(255, 255, 255, 0.5);
      .card {
        background-color: lighten($sub-primary-white, 3%);
        border: 1px solid $secondary-white;
        border-radius: 20px;
        color: $secondary;
        letter-spacing: 1px;
        line-height: 1.75em;
        padding: 20px 15px;
        @media (min-width: 992px) {
          padding: 30px;
        }
        .card-img-top {
          width: 50%;
          max-width: 150px;
          height: auto;
        }
        .dashed {
          border-bottom: 2px dashed $secondary-white;
        }
        .card-body{
          h4{
            letter-spacing: 5px;
          }
          div{
            letter-spacing: 2px;
            line-height: 2rem;
          }
        }
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
